import { render, staticRenderFns } from "./create-customer-receipt.vue?vue&type=template&id=e5e4aff8&"
import script from "./create-customer-receipt.vue?vue&type=script&lang=js&"
export * from "./create-customer-receipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports